export const PXIconBlocks = (function() {
	'use strict';
	
	let $header, $arrowSVG, $iconBlock,$imgBlock;

	function init() {
		$header = $('.block-copy .h3');
		$arrowSVG = $('<svg width="18px" height="12px" viewBox="0 0 18 12" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"> <title>Arrow</title> <g id="Style-Guide" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linejoin="round"> <g transform="translate(-189.000000, -3530.000000)" id="Arrow" stroke="#4C54F1" stroke-width="2.5"> <g transform="translate(189.000000, 3531.000000)"> <line x1="0" y1="4.58333333" x2="16" y2="4.58333333" id="Stroke-1"></line> <polyline id="Stroke-3" points="9.74117647 0 16 5.00052737 9.74117647 10"></polyline> </g> </g> </g></svg>');
		$iconBlock = $('.pxblock--icon-blocks');
		$imgBlock = $('.pxblock--copy-image');
		events();
	}

	function events() {
		$header.append($arrowSVG);
		$iconBlock.next('.pxblock--copy-image').addClass('padding--minus-top');
	}

	return {
		init: init
	};
})();


